<div class="about-div">

    <section id="about-us" class="section grey_bg_color about section-padding">
        <div class="container">
            <div class="section-title text-center">
                <h2 class="wow fadeInUp" data-wow-delay=".2s">About Us</h2>
                <p class="wow fadeInUp" data-wow-delay=".4s">Algorithmic Development & Trading<!-- Start working with etoro that can provide everything you need to generate awareness, drive traffic, connect. --></p>
            </div>

            <div class="row">
                <div class="col-lg-4 col-12 mt-4">
                    <div class="featuresBox wow fadeInLeft" data-wow-delay="1s">
                        <div class="icon">
                            <img src="assets/img/step_1.png" alt="Algorithmic Development & Trading" class="img-fluid">
                        </div>
                        <div class="content mt-5">
                            <h3>Cosmic Algorithm Ltd</h3>
                            <p>Develops algorithms to trade the Global Financial Markets, servicing, Fund Managers from within the Financial Services Industry</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-12 mt-4">
                    <div class="featuresBox wow fadeInUp" data-wow-delay=".6s">
                        <div class="icon">
                            <img src="assets/img/step_2.png" alt="Cosmic Algorithm Ltd" class="img-fluid">
                        </div>
                        <div class="content mt-5">
                            <h3>Backseat-Trader</h3>
                            <p>A specifically developed algorithm intended to be copy-traded by individuals wanting exposure to invest part of their future wealth planning strategy in these markets.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-12 mt-4">
                    <div class="featuresBox wow fadeInRight" data-wow-delay="1s">
                        <div class="icon">
                            <img src="assets/img/step_3.png" alt="Backseat-Trader" class="img-fluid">
                        </div>
                        <div class="content mt-5">
                            <h3>eToro</h3>
                            <p>The platform used to allow people copy other experienced traders strategies at no cost to the copier; The platform pays these costs to the traders being copied. </p>
                        </div>
                    </div>
                </div>

            </div>
        <!--  <div class="note text-center mt-4 pt-4 wow fadeInUp" data-wow-delay="1.4s">Our algorithm is based on a risk / return model which is moderate, targeting a 15 - 20% gain for the copier annually.</div> -->
        </div>
    </section>

    <section class="section_wrapper bg__color">
        <div class="container">
            <div class="row">
                <div class="col-md">
                    <div class="note wow fadeInUp" data-wow-delay=".2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <h3 class="heading">Our algorithm is based on a risk / return model which is moderate, <br />targeting a 15 - 25% gain for you annually.<!-- Our algorithm is based on a risk / return model which is moderate, targeting a 15 - 20% gain for the copier annually. --></h3>
                    </div>
                </div>
                <div class="col-md-auto col-sm-12">
                    <div class="btnBox wow fadeInUp" data-wow-delay=".6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                        <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term=" target="_blank" class="btn theme-btn hoverclr animate JoinusoneToro2">Join us on eToro</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>